(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[601],{

/***/ 56163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./src/constants/index.ts + 6 modules
var constants = __webpack_require__(22120);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Policies/buyer-protections.tsx








function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "Ryan Hill",
      dateTime: "2023-04-18",
      tag: "Policy",
      title: "Buyer Protections",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "To make buying on OneShop simple and safe, we have policies in place for each purchase:"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Shipping Guarantees"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sellers have 3 business days to ship all orders, excluding US bank holidays."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "If a seller cannot ship on time, you will be awarded a $10 courtesy credit."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tracking and shipping insurance are included on all orders."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "For orders above $300, a signature on delivery, or explicit waiver through the carrier, is required."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Details information can be found on our ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "/policies/shipping-options",
          children: "Shipping Options page"
        }), "."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Returns and Refunds"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Within 24 hours of delivery, OneShop requests a video unboxing of the order sent to", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "mailto:unboxing@oneshop.com",
            target: "_blank",
            children: "unboxing@oneshop.com"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Orders without unboxing videos are ", /*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "ineligible"
          }), " for returns or disputes."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Orders with valid unboxing videos that do not match their listing description can be submitted to support to begin a refund claim."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["We don't handle authentication. For more info, see our", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            style: {
              color: constants/* BrandColor.Bolt */.Te.Bolt
            },
            href: "/policies/item-authentication",
            children: "authentication policy"
          }), "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Approved returns will be sent a shipping label and must be shipped back to the seller in full within 24 hours of receiving the prepaid label."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "A full refund will be issued once final redelivery of all items is confirmed by the original seller."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Canceling Orders"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "All orders are final and cannot be canceled."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Orders that the seller does not fulfill will be resolved via the OneShop team. If it has been 3 business days, please reach out to ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: "/contact",
            children: "OneShop support"
          }), "."]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/policies/buyer-protections.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Buyer Protections | OneShop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Buyer protections on OneShop."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/policies/buyer-protections"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/policies/buyer-protections"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image')]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 92179:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/buyer-protections",
      function () {
        return __webpack_require__(56163);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(92179); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);